module.exports = __webpack_public_path__ + "static/4-create-token-62f8f7f6b66f4291e30fc8f443eba890.png";